import { getValue } from "@/src/features/firebase/initFirebase";
import {
  REMOTE_CONFIG_KEY_PLAID_FREE_TRIAL_DAYS,
  REMOTE_CONFIG_KEY_PLAID_GATE_MODE,
} from "@/src/features/firebase/remoteConfigKeys";

import {
  parsePlaidFreeTrialDays,
  parsePlaidGateMode,
  PLAID_FREE_TRIAL_DAYS_DEFAULT,
  PLAID_GATE_MODE_DEFAULT,
  type PlaidGateRemoteConfig,
} from "./plaidGateRemoteConfigShared";

export type {
  PlaidGateMode,
  PlaidGateRemoteConfig,
} from "./plaidGateRemoteConfigShared";
export {
  parsePlaidFreeTrialDays,
  parsePlaidGateMode,
  PLAID_FREE_TRIAL_DAYS_DEFAULT,
  PLAID_GATE_MODE_DEFAULT,
} from "./plaidGateRemoteConfigShared";

/**
 * 读取 Firebase RC：`plaid_gate_mode` / `plaid_free_trial_days`。
 * 失败或缺失时降级为 free_trial / 30（文案展示用；权威试链天数在后端）。
 */
export async function fetchPlaidGateRemoteConfig(): Promise<PlaidGateRemoteConfig> {
  try {
    const [modeValue, daysValue] = await Promise.all([
      getValue(REMOTE_CONFIG_KEY_PLAID_GATE_MODE),
      getValue(REMOTE_CONFIG_KEY_PLAID_FREE_TRIAL_DAYS),
    ]);
    return {
      mode: parsePlaidGateMode(modeValue.asString()),
      freeTrialDays: parsePlaidFreeTrialDays(daysValue.asString()),
    };
  } catch {
    return {
      mode: PLAID_GATE_MODE_DEFAULT,
      freeTrialDays: PLAID_FREE_TRIAL_DAYS_DEFAULT,
    };
  }
}
